/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import { AbrainLogo } from '@coze-studio/abr-brand';
import { I18n } from '@coze-arch/i18n';

import {
  ABR_INTEGRATION_PORTAL_URL,
  ABR_ONTOLOGY_PORTAL_URL,
} from '../constants';
import { AccountDropdown } from './account-dropdown';

import styles from './abr-top-bar.module.less';

export const AbrTopBar: FC = () => (
  <header className={styles.topbar}>
    <div className={styles.logoWrap}>
      <AbrainLogo
        showText
        subtitle={I18n.t('abr_shell_product_subtitle')}
        size={32}
      />
    </div>
    <nav className={styles.productNav}>
      <a
        href={ABR_INTEGRATION_PORTAL_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {I18n.t('abr_shell_nav_integration')}
      </a>
      <a
        href={ABR_ONTOLOGY_PORTAL_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {I18n.t('abr_shell_nav_ontology')}
      </a>
      <span className={styles.productActive}>
        {I18n.t('abr_shell_nav_agent')}
      </span>
    </nav>
    <div className={styles.topbarRight}>
      <AccountDropdown />
    </div>
  </header>
);
